var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material';
import { SisTranslateModule, } from '@synisys/idm-frontend-shared';
import { IExpressionEvaluationService, MultilingualEditorModule, } from '@synisys/idm-xml-template-builder';
import { DynamicTemplateEditorComponent } from './dynamic-template-editor.component';
import { ExpressionEvaluationService } from './expression-evaluation.service';
import { TemplateBuilderCommunicationService } from './template-builder-communication.service';
var DynamicTemplateModule = /** @class */ (function () {
    function DynamicTemplateModule() {
    }
    DynamicTemplateModule = __decorate([
        NgModule({
            imports: [
                MultilingualEditorModule,
                SisTranslateModule,
                MatButtonModule,
                CommonModule,
            ],
            declarations: [DynamicTemplateEditorComponent],
            exports: [DynamicTemplateEditorComponent],
            providers: [
                TemplateBuilderCommunicationService,
                {
                    provide: IExpressionEvaluationService,
                    useClass: ExpressionEvaluationService,
                },
            ],
        })
    ], DynamicTemplateModule);
    return DynamicTemplateModule;
}());
export { DynamicTemplateModule };
//# sourceMappingURL=dynamic-template.module.js.map